import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { UpdateObligationOversightResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateObligationOversightResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export type UpdateObligationOversightResultInput = {
  Id: string;
  Rating?: number | null;
  Rationale?: string | null;
  TestDate?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useUpdateObligationOversightResult = createMutationHook({
  name: 'updateObligationOversightResult',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.assessment.updateObligationOversightResult.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: UpdateObligationOversightResultInput) => input,
  invalidate: (trpc) => [
    // Apollo parity: evictField(cache, 'obligation_oversight_result')
    trpc.frontend.assessment.getOversightResultsByParentId.pathKey(),
    trpc.frontend.assessment.getAllOversightAssessmentResults.queryKey(),
    trpc.frontend.assessment.oversightResultById.pathKey(),
    trpc.frontend.assessment.obligationOversightResultById.pathKey(),
    trpc.frontend.assessment.oversightAssessmentObligationAssessmentResultsByObligationId.pathKey(),
    // Apollo parity: evictField(cache, 'obligation_oversight_result_aggregate')
    trpc.frontend.assessment.oversightAssessmentResultCount.queryKey(),
    // Apollo parity: evictField(cache, 'oversight_assessment')
    trpc.frontend.assessment.oversightActivityRegister.queryKey(),
    trpc.frontend.assessment.oversightActivityCount.queryKey(),
  ],
  mapResponse: (): UpdateObligationOversightResultMutation => ({
    update_obligation_oversight_result: {
      __typename: 'obligation_oversight_result_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateObligationOversightResultDocument,
  graphqlVariables: (input: UpdateObligationOversightResultInput) => ({
    Id: input.Id,
    Rating: input.Rating,
    Rationale: input.Rationale,
    TestDate: input.TestDate,
    CustomAttributeData: input.CustomAttributeData ?? null,
  }),
  evictFields: [
    'obligation_oversight_result',
    'oversight_assessment',
    'obligation_oversight_result_aggregate',
  ],
});
